// extracted by mini-css-extract-plugin
export default {"dlTableWrapper":"src-js-containers-grid-components-AgGridWrapper---dlTableWrapper---Fzt0d"};